module.exports = __webpack_public_path__ + "media/conversa/ico_conversa_float-4dda3feb.png";